<template >
  <span v-if="showPage && pageItemDetail && resolvedComponent">
    <HeaderBannerCustom  v-if="siteSettings.HomePageHeaderCustom && pageType == 'IP'" :intro-one="siteSettings.HomePageHeaderCustom"/>
    <HeaderBannerContent v-else-if="pageItemDetail.Header  && pageType !== 'ERROR'" :header="pageItemDetail.Header"/>

    <Uspbar v-if="pageItemDetail.Usp && pageItemDetail.Usp.length >= 2  && pageType !== 'ERROR'" />
    <Breadcrumbs v-if="pageType !== 'NF' && pageType !== 'IP'  && pageType !== 'ERROR'"
    class="position-absolute"
    />
    <HeaderOne v-if="(pageType !== 'IP' && pageType !== 'ERROR' && pageType !== 'PD' && getYesNo(pageItemDetail, 'TitleShow') || pagetypeNVEARItem(pageType))"
      class="HeaderOne pt-5"
      :headerOne="pageItemDetail.PageTitle || pageItemDetail.Title"
    />

    <!-- VA en DV gebruiken de getYesNo function. Voor nu handlen op oude manier -->
    <VacancyDetail          :vacancy="pageItemDetail"  v-if="pageType === 'VA' && getYesNo(siteSettings, 'Carerix')"/>
    <VacancyComponentOld    :vacancy="pageItemDetail"  v-if="pageType === 'VA' && !getYesNo(siteSettings, 'Carerix')"/>
    <VacancyOverview        :pageItem="pageItemDetail" v-if="pageType === 'DV' && getYesNo(siteSettings, 'Carerix')"/>
    <VacanciesOverviewOld   :pageItem="pageItemDetail" v-if="pageType === 'DV' && !getYesNo(siteSettings, 'Carerix')"/>

    <component
      :is="resolvedComponent"
      v-bind="{[componentPropName]: pageItemDetail}"
      v-if="pageType !== 'VA' && pageType !== 'DV'"
    />

    <Downloads :pageItem="pageItemDetail"/>
    <div v-if="pageType === 'ERROR'">
      <v-alert type="error" dense>
        <div class="d-flex align-center justify-space-between">
          <span>{{ errorString }}</span>
          <v-btn small @click="reloadPage" color="white" text>
            <v-icon small left>mdi-refresh</v-icon>
            {{ dataAll.getStatic('product_loading_error_reload', 'Reload page') }}
          </v-btn>
        </div>
      </v-alert>
    </div>
    <OfferModal/>
  </span>
</template>

<script setup lang="ts">
// components for this view (@ is an alias to /src)
// import HeaderApplication from "@/components/Base/headerApplication.vue";
import HeaderBannerContent from "@/components/Base/HeaderBannerContent.vue";
import HeaderBannerCustom from "@/components/Base/HeaderBannerCustom.vue";
import Breadcrumbs from "@/components/Base/breadCrumbs.vue";
import HeaderOne from "@/components/Base/headerOne.vue";
import Uspbar from "@/components/Base/uspBar.vue";
import Downloads from "@/components/Base/downloads.vue";
import OfferModal from "@/components/Base/offerModal.vue";

import VacancyOverview from "@/layers/vacancies/components/VacancyOverview.vue";
import VacancyDetail from '@/layers/vacancies/components/VacancyDetail.vue';
import VacanciesOverviewOld from "@/components/Vacancy/vacanciesOverview.vue";
import VacancyComponentOld from "@/components/Vacancy/vacancyComponent.vue";

import { getPageComponent, getPagePropName } from "~/services/pageComponentRegistry";

const { $methods, $headerMethods, $redir} = useNuxtApp()
const dataAll = useDataAll();
const { setPageType } = usePageTypeStore();
const siteSettings = useSiteSettingsStore()
const checkFields = ["BrowserTitle", "Code","MetaDescription","MetaKeywords","MetaTitle","PageType","NameMenu","NameUrl","Title"];
let showPage = ref(false);
let toonUSP = ref(false);

let pageType = ref("");
let errorString = ref("");
const isServer = ref(false);
const route = useRoute();

if (import.meta.server) {
  isServer.value = true;
}

/*
All pagetypes
1	PS	Productgroep Semantisch
2	PM	Productgroep Merk
3	MD	Google Maps detail locatie + contactgegevens
4	ML	Contact - Google Maps overzicht meerdere locaties
5	DC	Disclaimer Copyright Cookies
6	VW	Voorwaarden
7	DN	Nieuws
8	NA	Nieuwsbrief aanmelding
9	DE	Evenementen/Beurzen
10	DV	Vacatures
11	DA	Acties/promos
12	DR	Referentie/Toepassing
13	PG	Profiel - geschiedenis x
14	SD	Service of Dienst
15	HP	Help Pagina
16	WP	White Paper
17	NF	Not Found
19	ES	ES alle artikelen
20	WW	Shop Winkelwagen
21	WB	Shop Betalen
30	IT	Intranet Telefoongids Smoelenboek x
31	IL	Intranet LiveViewer
99	TS	Test Pagina x
*/

let pageItemDetail: any = null
const nuxtApp = $methods

const resolvedComponent = computed(() => {
  if (!pageItemDetail) return null;
  return getPageComponent(pageType.value)
})

const componentPropName = computed(() => {
  return getPagePropName(pageType.value)
})

const { data: pageData } = await useAsyncData(
  () => `page:${route.fullPath}`,
  async () => {
    const res: any = await usePageRepository(route)
    return {
      res,
      errorStringLoad: dataAll.getDataVar("errorStringLoad")
    }
  }
)

// Navbar stands in the layout; transfer state navbarOnImage depending on page properties
const navbarOnImage = useState('navbarOnImage', () => false)

watchEffect(() => {
  const p = pageData.value?.res
  navbarOnImage.value = !!(
    (siteSettings?.HomePageHeaderCustom && p?.PageType === 'IP') ||
    (siteSettings?.Header?.[0]?.HeaderImage && p?.PageType === 'IP') ||
    (p?.Header?.HeaderImage && p?.PageType !== 'IP') ||
    (p?.Header?.[0]?.HeaderImage && p?.PageType !== 'IP')
  )
})



watch(pageData, async (value) => {
  if (!value) return
  const { res, errorStringLoad } = value
  if (errorStringLoad) {
    console.log('errorstringload');
    pageType.value = 'ERROR';
    showPage.value = true;
    errorString.value = errorStringLoad;
    dataAll.setDataVar('errorStringLoad', '')
    return;
  }

  if (!res || res === "" || res === null) {
    if (import.meta.server) {
      const event = useRequestEvent();
      if (event) setResponseStatus(event, 404);
    }
    const NF = usePageOverviewStore().getPageByType("NF");
    const nfPath = NF?.NameUrl ? ($methods as any).localePath("/" + NF.NameUrl) : "/404";
    if (route.fullPath !== nfPath) {
      await navigateTo(nfPath);
    }
    return;
  }

  if (res.PageType === 'NF') {
    if (import.meta.server) {
      const event = useRequestEvent();
      if (event) setResponseStatus(event, 404);
    }
    pageItemDetail = res;
    pageType.value = 'NF';
    errorString.value = '';
    showPage.value = true;

    ($headerMethods as any).formatHeader(pageItemDetail)
    const { setNameMenuNVEAR } = useNameMenuStore();
    setPageType(pageItemDetail.PageType);
    setNameMenuNVEAR(pageItemDetail.NameMenu ? pageItemDetail.NameMenu : pageItemDetail.NameUrl);
    return;
  }

  if (res.PageType != "PD" && !(nuxtApp as any).checkObjectFieldsExists(res, checkFields, "Page JSON") ){
    pageType.value = 'ERROR';
    showPage.value = true;
    errorString.value = "JSON ERROR, fields missing"
    return [];
  }

  pageItemDetail = res;
  pageType.value = res.PageType;
  errorString.value = ''
  showPage.value = true;

  // set header info
  ($headerMethods as any).formatHeader(pageItemDetail)
  const { setNameMenuNVEAR } = useNameMenuStore();
  setPageType(pageItemDetail.PageType);
  setNameMenuNVEAR(pageItemDetail.NameMenu ? pageItemDetail.NameMenu : pageItemDetail.NameUrl);
  if (!isServer.value) {
    toonUSP.value = isset(res.Usp) && res.Usp.length > 0;
  }

}, { immediate: true })

// watch(
//   () => dataAll.loadedSuccessfully,
//   async (loaded) => {
//     if (!loaded || !import.meta.client) return;
//
//     try {
//       const res: any = await usePageRepository(useRoute());
//
//       if (dataAll.getDataVar("errorStringLoad") != ''){
//         console.log('errorstringload');
//         pageType.value = 'ERROR';
//         showPage.value = true;
//         errorString.value =dataAll.getDataVar("errorStringLoad")
//         dataAll.setDataVar('errorStringLoad', '')
//         return [];
//       }
//       else if (!res || res === "" || res === null) {
//         const NF = usePageOverviewStore().getPageByType("NF");
//         const nfPath = NF?.NameUrl ? ($methods as any).localePath("/" + NF.NameUrl) : "/404";
//         return navigateTo(nfPath);
//       }
//
//       else if (res.PageType != "PD" && !(nuxtApp as any).checkObjectFieldsExists(res, checkFields, "Page JSON") ){
//         pageType.value = 'ERROR';
//         showPage.value = true;
//         errorString.value = "JSON ERROR, fields missing"
//         return [];
//       }
//
//       pageItemDetail = res;
//       pageType.value = res.PageType;
//       errorString.value = ''
//       showPage.value = true;
//
//       // set header info
//       ($headerMethods as any).formatHeader(pageItemDetail)
//       const { setNameMenuNVEAR } = useNameMenuStore();
//       setPageType(pageItemDetail.PageType);
//       setNameMenuNVEAR(pageItemDetail.NameMenu ? pageItemDetail.NameMenu : pageItemDetail.NameUrl);
//       if (!isServer.value) {
//         toonUSP.value =  isset(res.Usp) && res.Usp.length > 0;
//       }
//
//     }
//     catch (err) {
//       console.error(err);
//       const NF = usePageOverviewStore().getPageByType("NF");
//       const nfPath = NF?.NameUrl ? ($methods as any).localePath("/" + NF.NameUrl) : "/404";
//       return navigateTo(nfPath);
//     }
//   },
//   { immediate: true }
// )

function pagetypeNVEARItem(pageType: string){
  // Carefix vacancy don't show header one, H1 is shown in vancansy itself
  if (getYesNo(siteSettings, 'Carerix') && pageType == "VA"){
    return false;
  }

  if (pageType == "NI" || pageType == "EV" || pageType == "VA" || pageType == "AC" || pageType == "RE" ){
    return true;
  }
  return false;
}

function reloadPage(){
  window.location.reload();
}

</script>